import {} from "react-router";

import React, { Component } from "react";

import authenticationService from "../services/AuthenticationService";
import { withRouter, Redirect } from "react-router-dom";
import { setEmbeddedFromLocalStorage } from "../util/utils";
import { FOLDER_HOMOL } from "../constants";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: null,
      userTypeName: "Tipo de Usuário",
      login: null,
      password: null,
      loading: true,
      isUserAuthenticated: false,
      relatedClients: [],
      clientId: null,
      clientName: null,
      nextLoginPhase: false,
      errorMessage: null,
    };

    this.items = ["Laboratório Conveniado", "Pessoa Física"];
    //this.items = ["Laboratório Conveniado", "Pessoa Física", "Hospital"];
    this.showPasswordFn = this.showPassword.bind(this);

    window.addEventListener("showPassword", this.showPasswordFn);
  }

  async componentDidMount() {
    this.getQuery("embedded");
    let loading = false;
    this.setState({ loading });
    await this.checkForExternalLogin();
    let isUserAuthenticated = authenticationService.checkIfUserAuthenticated();
    this.setState({ isUserAuthenticated });
  }

  getQuery(queryName) {
    const query = new URLSearchParams(this.props.location.state && this.props.location.state.search);

    if (query.get(queryName)) {
      query.get(queryName).toLowerCase() === "true"
        ? setEmbeddedFromLocalStorage(true)
        : setEmbeddedFromLocalStorage(false);
    } else {
      setEmbeddedFromLocalStorage(false);
    }
  }

  async login(e) {
    e.preventDefault();

    this.setState({ loading: true });

    if (this.state.userType && this.state.login && this.state.password) {
      let authentication = await authenticationService.login(
        this.state.login,
        this.state.password,
        this.state.userType
      );
      this.setState({
        errorMessage: ""
      })
      if (
        authentication &&
        authentication.status &&
        authentication.relatedClients
      ) {
        this.setState({ relatedClients: authentication.relatedClients });
        this.setState({ loading: false });
      } else if (authentication && authentication.status) {
        this.setState({ loading: false, isAuthenticated: true });

        this.props.history.replace("/");
      } else {
        this.setState({ loading: false });
        this.showErrorMessage("Login ou senha incorretos.");
      }
    } else {
      this.setState({ loading: false });
      this.showErrorMessage("Preencha corretamente todos os campos.");
    }
  }

  async checkForExternalLogin() {
    const query = new URLSearchParams(this.props.location.state && this.props.location.state.search);
    let externalToken = query.get('sessionId');
   
    if (externalToken) {
      this.setState({ loading: true });
      let authentication =
        await authenticationService.checkIfTokenValidOnRemote(externalToken);
      if (!authentication) {
        this.showErrorMessage("Login ou senha incorretos.");
        authenticationService.endSession();
      } else {
        authenticationService.registerSession("myPardini");
      }

      this.setState({ loading: false });
      return true;
    }
  }

  showPassword() {
    let showPassword = document.querySelector(".show-password");
    let inputPassword = document.getElementById("userPassword");

    if (inputPassword.type === "password") {
      inputPassword.type = "text";
      inputPassword.focus();
      showPassword.classList.add("hide");
    } else {
      inputPassword.type = "password";
      inputPassword.focus();
      showPassword.classList.remove("hide");
    }
  }

  toggleList() {
    let menu = document.querySelector(".type-list");
    if (!menu.classList.contains("user-type-menu")) {
      menu.classList.add("user-type-menu");
    } else {
      menu.classList.remove("user-type-menu");
    }
  }

  getString(id) {
    let tipo = "";
    if (id === "L2L") {
      tipo = "Laboratório Conveniado";
    } else if (id === "PSC") {
      tipo = "Pessoa Física";
    } else if (id === "HOSP") {
      tipo = "Hospital";
    } else {
      tipo = null;
    }
    return tipo;
  }

  toggleUserType(id) {
    let options = document.getElementsByClassName("dropdown-item");

    for (var c = 0; c < options.length; c++) {
      if (options[c].classList.contains("active")) {
        options[c].classList.remove("active");
      }
    }

    let active = document.getElementById(id);

    active.classList.add("active");

    document.querySelector(".type-list").classList.remove("user-type-menu");
    this.setState({
      userType: id,
      userTypeName: this.getString(id),
    });
  }
  toggleClientType(id, name) {
    let options = document.getElementsByClassName("dropdown-item");

    for (var c = 0; c < options.length; c++) {
      if (options[c].classList.contains("active")) {
        options[c].classList.remove("active");
      }
    }

    let active = document.getElementById(id);

    active.classList.add("active");

    document.querySelector(".type-list").classList.remove("user-type-menu");

    this.setState({
      clientId: id,
      clientName: name,
    });
  }

  async setClient(e) {
    e.preventDefault();

    if (this.state.clientId && this.state.clientName) {
      this.setState({ loading: true });
      let authentication = await authenticationService.setUserClient(
        this.state.clientId,
        this.state.clientName
      );

      if (authentication && authentication.status) {
        this.props.history.push("/");
      } else {
        alert("erro");
      }
    } else {
      this.showErrorMessage("Selecione um  laboratório para prosseguir.");
    }
    this.setState({ loading: false });
  }

  toggleForm(id, ctrl) {
    if (ctrl === 0) {
      document.getElementById(id).classList.add("focus");
      document.getElementById(id).classList.add("filled");
    } else if (
      ctrl === 1 &&
      document.getElementById(id).children[1].value === ""
    ) {
      document.getElementById(id).classList.remove("focus");
      document.getElementById(id).classList.remove("filled");
    }
  }

  attLogin() {
    let login = document.getElementById("userLogin").value;
    this.setState({ login });
  }
  attPassword() {
    let password = document.getElementById("userPassword").value;
    this.setState({ password });
  }

  showErrorMessage(message) {
    this.setState({ errorMessage: message });
  }

  render() {
    const ulStyle = {
      overflow: "auto",
      maxHeight: "150px",
    };
    const btDefaultStyle = {
      boxShadow: "none",
      width: "100%",
      position: "absolute",
      paddingLeft: "15%"
    };

    return !this.state.isUserAuthenticated ? (
      <>
        {this.state.loading ? <div id="loader" /> : null}
        <div className="login-container">
          <div className="login-intro">
            <div className="login-enterprise-digital">Enterprise Digital</div>
            {/* <div className="login-intro-content"></div> */}
          </div>
          <div className="login-content">
            <h1 className="login-title login-title-ico">
              <span className="text-gradient">Login</span>
            </h1>
            <form className="login-form">
              {!(
                this.state.relatedClients &&
                this.state.relatedClients.length &&
                this.state.relatedClients.length > 0
              ) ? (
                <>
                  <div className=" user-type">
                    <div className="dropdown" id="dropdown-user-type">
                      <div
                        className="type-dropdown type-btn "
                        role="button"
                        onClick={() => this.toggleList()}
                        style={{ padding: "0 0" }}
                      >
                        <div className="type-section">
                          <div className="type-icon"></div>
                          <div
                            className=" type-label type-dropdown"
                            role="button"
                            id="orderExams"
                            data-target="dropdown-user-type"
                            aria-expanded="false"
                            style={btDefaultStyle}
                          >
                            {this.state.userTypeName}
                          </div>
                        </div>
                      </div>
                      <ul
                        className="dropdown-menu dropdown-menu-end dropdown-menu-default type-list"
                        aria-labelledby="orderExams"
                      >
                        <li
                          className="dropdown-item type-dropdown"
                          id="L2L"
                          onClick={() => this.toggleUserType("L2L")}
                        >
                          Laboratório Conveniado
                        </li>
                        <li
                          className="dropdown-item type-dropdown"
                          id="PSC"
                          onClick={() => this.toggleUserType("PSC")}
                        >
                          Pessoa Física
                        </li>
                        {/* <li
                          className="dropdown-item type-dropdown"
                          id="HOSP"
                          onClick={() => this.toggleUserType("HOSP")}
                        >
                          Hospital
                        </li> */}
                      </ul>
                    </div>
                  </div>
                  <div
                    className="form-group label-inside form-group-ico ico-user focus filled"
                    id="user-div"
                  >
                    <label htmlFor="userLogin" className="form-label">
                      Nome
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="userLogin"
                      onChange={() => this.attLogin()}
                    />
                  </div>

                  <div
                    className="form-group label-inside form-group-ico ico-lock focus filled"
                    id="password-div"
                  >
                    <label htmlFor="userPassword" className="form-label">
                      Senha
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="userPassword"
                      onChange={() => this.attPassword()}
                    />
                    <span
                      className="show-password"
                      onClick={() => this.showPassword()}
                    >
                      mostrar/esconder senha
                    </span>
                  </div>
                  {this.state.errorMessage ? (
                    <div  style={{minHeight: 80, display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <div className="msg-alert">{this.state.errorMessage}</div>
                    </div>
                    ) : (
                    <div style={{ minHeight: 80}}></div>
                  )}
                  <button
                    type="submit"
                    className="bt"
                    onClick={(e) => {
                      this.login(e);
                    }}
                  >
                    Acessar
                  </button>
                </>
              ) : (
                <>
                  <div className=" user-type">
                    <div className="dropdown" id="dropdown-user-lab">
                      <div
                        className="type-dropdown type-btn "
                        role="button"
                        onClick={() => this.toggleList()}
                        style={{ padding: "0 0" }}
                      >
                        <div className="type-section">
                          <div className="type-icon"></div>
                          <div
                            className=" type-label type-dropdown"
                            role="button"
                            id="orderExams"
                            data-target="dropdown-user-lab"
                            aria-expanded="false"
                            style={btDefaultStyle}
                          >
                            {this.state.clientName ||
                              `Selecione o ${this.state.userTypeName}`}
                          </div>
                        </div>
                      </div>
                      <ul
                        className="dropdown-menu dropdown-menu-end dropdown-menu-default type-list"
                        aria-labelledby="orderExams"
                        style={ulStyle}
                      >
                        {this.state.relatedClients.map((user) => (
                          <li
                            className="dropdown-item type-dropdown"
                            id={user.code}
                            onClick={() =>
                              this.toggleClientType(user.code, user.name)
                            }
                          >
                            {`${user.code} - ${user.name}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  {this.state.errorMessage ? (
                    <div  style={{minHeight: 80, display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <div className="msg-alert">{this.state.errorMessage}</div>
                    </div>
                  ) : (
                    <div style={{ minHeight:80}}></div>
                  )}
                  <button
                    className="bt"
                    onClick={(e) => {
                      this.setClient(e);
                    }}
                  >
                    Concluir
                  </button>
                </>
              )}
            </form>
            <div className="logo-hermes-pardini">Hermes Pardini</div>
          </div>
        </div>
      </>
    ) : (
      <Redirect to={`${FOLDER_HOMOL}/`} />
    );
  }
}

export default withRouter(Login);
